export const dashboardConstants = {
    DASHBOARD_STORE_REQUEST: "DASHBOARD_STORE_REQUEST",
    DASHBOARD_STORE_SUCCESS: "DASHBOARD_STORE_SUCCESS",
    DASHBOARD_STORE_FAILURE: "DASHBOARD_STORE_FAILURE",
    DASHBOARD_STORE_CLEAR: "DASHBOARD_STORE_CLEAR",
    EXHIBITION_STATE_SUCCESS: "EXHIBITION_STATE_SUCCESS",
    EXHIBITION_STATE_FAILURE: "EXHIBITION_STATE_FAILURE"
};
